<template>
  <fragment>
    <EconomicGroupDetails v-bind="[$attrs, $props]" v-on="$listeners">
      <template v-slot:header>
        <slot name="header" />
      </template>
    </EconomicGroupDetails>
    <v-divider />
    <FormSection class="pt-9 mb-10" title="ESTRUTURA DE ATENDIMENTO LOCKTON">
      <AnswerDetails v-bind="[$attrs, $props]" v-on="$listeners" />
    </FormSection>
    <v-divider />
    <ClientContactSelection v-bind="[$attrs, $props]" v-on="$listeners" />
    <v-divider />
    <FormSection class="pt-9" title="ESCRITÓRIOS DE ADVOCACIA">
      <AdvisoryDetails v-bind="[$attrs, $props]" v-on="$listeners" />
    </FormSection>
    <v-divider />
    <FormSection class="pt-9" title="DOCUMENTOS">
      <DocumentSelection v-bind="[$attrs, $props]" v-on="$listeners" />
    </FormSection>
  </fragment>
</template>

<script>
import FormSection from "@/components/FormSection.vue";
import EconomicGroupDetails from "../components/form/EconomicGroupDetails.vue";
import AnswerDetails from "../components/form/AnswerDetails.vue";
import ClientContactSelection from "../components/form/ClientContactSelection.vue";
import AdvisoryDetails from "../components/form/AdvisoryDetails.vue";
import DocumentSelection from "../components/form/DocumentSelection.vue";

export default {
  name: "NewEconomicGroupForm",
  components: {
    FormSection,
    EconomicGroupDetails,
    AnswerDetails,
    ClientContactSelection,
    AdvisoryDetails,
    DocumentSelection
  },
  props: {
    value: Object
  }
};
</script>
